import React from 'react';
type ChristmasSectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  titleId: string;
  tone?: 'dark' | 'light';
  align?: 'center' | 'left';
};
export function ChristmasSectionHeading({
  eyebrow,
  title,
  description,
  titleId,
  tone = 'dark',
  align = 'center'
}: ChristmasSectionHeadingProps) {
  const light = tone === 'light';
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-237" data-mp="jsz1o8301xxf">
      <p className={`inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] ${light ? 'text-[#E3C77F]' : 'text-olive'}`} data-id="element-238" data-mp="ntrdn939agxe">
        <span aria-hidden="true" className="h-px w-8 bg-current" data-id="element-239" data-mp="srb2t41hse44" />
        {eyebrow}
        {align === 'center' && <span aria-hidden="true" className="h-px w-8 bg-current" data-id="element-240" data-mp="2ukh2ob4pnhsc" />}
      </p>
      <h2 id={titleId} className={`mt-5 font-display text-4xl font-medium leading-tight tracking-tight md:text-5xl ${light ? 'text-white' : 'text-forest'}`} data-id="element-241" data-mp="2umlfxjoi1t5a">
        {title}
      </h2>
      {description && <p className={`mt-4 text-lg leading-relaxed ${light ? 'text-white/75' : 'text-forest/70'}`} data-id="element-242" data-mp="2fodya446gaa8">{description}</p>}
    </div>;
}